import { createAsyncThunk } from '@reduxjs/toolkit';
import { itemService } from 'services';
import { listMedicalSearchRequest } from 'types';

export const getListMedicalFromCPAP = createAsyncThunk<
  any,
  { pageNumber: number; perPage: number; searchValue?: listMedicalSearchRequest }
>('medical/getItemsFromCPAP', async (params) => {
  try {
    const conditions: any[] = getConditions(params);
    const response = await itemService.filterCPAP({
      conditions,
      page: params.pageNumber,
      per_page: params.perPage,
      disable_include_links: true,
      disable_include_lookups: true,
      sort_fields: [
        { id: 'facility_name', order: 'asc' },
        { id: 'patient_id', order: 'asc' },
        { id: 'cpap_id', order: 'asc' },
      ],
    });

    return response.data;
  } catch (error) {
    console.log(error);
  }
});

export const getCpapInstructItems = createAsyncThunk<any, { pageNumber: number }>(
  'medical/getItems',
  async (params) => {
    try {
      const response = await itemService.filterCPAP({
        per_page: 20,
        page: params.pageNumber,
        conditions: [{ id: 'suspension_flg', search_value: ['1'], not_match: true }],
        disable_include_links: true,
        disable_include_lookups: true,
        sort_fields: [
          { id: 'facility_name', order: 'asc' },
          { id: 'patient_id', order: 'asc' },
          { id: 'cpap_id', order: 'asc' },
        ],
      });

      return response.data;
    } catch (e) {
      console.log(e);
    }
  },
);

export const getCsvListMedicalFromCPAP = createAsyncThunk<
  any,
  { pageNumber: number; perPage: number; searchValue?: listMedicalSearchRequest }
>('medical/getCsvItemsFromCPAP', async (params) => {
  try {
    const conditions: any[] = getConditions(params);
    const response = await itemService.filterCPAP({
      conditions,
      page: params.pageNumber,
      per_page: params.perPage,
      disable_include_links: true,
      disable_include_lookups: true,
      sort_fields: [
        { id: 'facility_name', order: 'asc' },
        { id: 'patient_id', order: 'asc' },
        { id: 'cpap_id', order: 'asc' },
      ],
    });

    return response.data;
  } catch (error) {
    console.log(error);
  }
});

function getConditions(params: any) {
  const conditions: any[] = [{ id: 'suspension_flg', search_value: ['1'], not_match: true }];
  params.searchValue?.period_of_no_visit_medical &&
    conditions.push({
      search_value:
        params.searchValue?.period_of_no_visit_medical === '2'
          ? [params.searchValue?.period_of_no_visit_medical, '2']
          : [params.searchValue?.period_of_no_visit_medical, null],
      id: 'period_of_no_visit_medical',
      include_null: false,
    });
  params.searchValue?.facility_name &&
    conditions.push({
      search_value: [params.searchValue.facility_name],
      id: 'facility_name_for_search',
      include_null: false,
    });
  params.searchValue?.patient_name &&
    conditions.push({
      search_value: [params.searchValue.patient_name],
      id: 'patient_name',
      include_null: false,
    });

  return conditions;
}
